
<template>
  <div class="media-hover">

    <h4 style="color:lightblue;" v-html="temp.title" v-if="temp.title"></h4>
    <ul v-if="temp.content">
      <li v-for="node in temp.content">
        <h4 v-html="node.sub"></h4>
        <p v-html="node.body"></p>
      </li>
    </ul>
    <img :src="setSrc()" />

  </div>
</template>

<script>

  export default {

    data(){
      return {
      }
    },

    props: ['temp'],

    methods: {

      setSrc(){
        if (this.temp.src) {
          return require(`@/assets/${this.temp.src}.png`);
        }
      }

    }

  }

</script>

<style scoped>

.media-hover {
  width: 400px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  background: #404342;
  color: #dce1ec;
  padding: 3%;
  border-left: none;
  border-radius: 4px;
  border: 1px solid #dce1ec;
}

img {
  width: 95%;
}

h3, h4, p {
  font-weight: lighter;
}

ul {
  width: 100%;
  margin-left: -20px;
}

h3 {
  color: lightblue;
  width: 100%;
}

li {
  list-style: none;
}

h4 {
  margin-bottom: 0px;
}

p {
  margin: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/hover/Media.vue